// Ступени «Табеля» (README, «Каркас экрана»): «до N px» — включительно.
import { useSyncExternalStore } from 'react';

export const breakpoints = {
  /** До 640 px: нижняя навигация, окна и карточка записи выезжают снизу. */
  phone: 640,
  /** До 900 px: меню выезжает поверх экрана. */
  tablet: 900,
  /** До 1100 px: одна колонка панелей. */
  narrow: 1100,
} as const;

export type Breakpoint = keyof typeof breakpoints;

export const media = {
  phone: `(width <= ${breakpoints.phone}px)`,
  tablet: `(width <= ${breakpoints.tablet}px)`,
  narrow: `(width <= ${breakpoints.narrow}px)`,
} as const satisfies Record<Breakpoint, string>;

function canMatch(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function';
}

/** Совпадает ли медиазапрос сейчас; без matchMedia (тесты, сервер) — false. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (notify) => {
      if (!canMatch()) return () => undefined;
      const list = window.matchMedia(query);
      list.addEventListener('change', notify);
      return () => list.removeEventListener('change', notify);
    },
    () => (canMatch() ? window.matchMedia(query).matches : false),
    () => false,
  );
}

/** Ширина до 640 px включительно. */
export function useIsPhone(): boolean {
  return useMediaQuery(media.phone);
}
